<template>
    <div class="d-flex on-off align-items-center" @click="toggle()">
        <div class="flex-fill on-off__label">
            <slot></slot>
        </div>
        <div>
            <span class="on-off__switch" :class="[{ on: state }]"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        state: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        toggle() {
            this.$emit('input', !this.state);
        },
    },
};
</script>

<style lang="scss" scoped>
.on-off {
    cursor: pointer;
}

.on-off__label {
    color: #4e3a30;
    font-size: 18px;
    font-weight: 500;
}

.on-off__switch {
    position: relative;
    display: block;
    width: 34px;
    height: 14px;
    border-radius: 7px;
    background-color: rgba(78, 58, 48, 0.2);
    cursor: pointer;
    transition: box-shadow 0.3s ease, background-color 0.3s ease;

    &:before {
        position: absolute;
        content: '';
        width: 20px;
        height: 20px;
        display: block;
        border-radius: 50%;
        background-color: #f6f0eb;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
        box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14),
            0 3px 14px 2px rgba(0, 0, 0, 0.12),
            0 5px 5px -3px rgba(0, 0, 0, 0.2);
        transition: box-shadow 0.3s ease, background-color 0.3s ease,
            margin 0.6s ease;
    }

    &:hover {
        &:before {
            box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14),
                0 3px 14px 2px rgba(0, 0, 0, 0.12);
        }
    }

    &.on {
        background-color: rgba(200, 83, 43, 0.4);
        &:before {
            background-color: #c8532b;
            margin-left: calc(100% - 16px);
        }
    }
}
</style>
